/*
 This file is part of GNU Taler
 (C) 2021-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

/**
 *
 * @author Sebastian Javier Marchano (sebasjm)
 */
import { ComponentChildren, h, VNode } from "preact";
import { useState } from "preact/hooks";
import { InputWithAddon } from "./InputWithAddon.js";
import { InputProps } from "./useField.js";

export interface Props<T> extends InputProps<T> {
  expand?: boolean;
  addonAfter?: ComponentChildren;
  children?: ComponentChildren;
  side?: ComponentChildren;
  autoComplete?: "current-password" | "new-password";
}

export function InputPassword<T>({
  name,
  readonly,
  label,
  placeholder,
  help,
  tooltip,
  expand,
  autoComplete,
  children,
  side,
}: Props<keyof T>): VNode {
  const [hide, setHide] = useState(true);
  return (
    <InputWithAddon<T>
      name={name}
      readonly={readonly}
      side={side}
      label={label}
      placeholder={placeholder}
      autoComplete={autoComplete}
      help={help}
      tooltip={tooltip}
      addonAfterAction={() => {
        setHide((h) => !h);
      }}
      addonAfter={
        hide ? (
          <i class="icon mdi mdi-eye-off" />
        ) : (
          <i class="icon mdi mdi-eye" />
        )
      }
      inputType={hide ? "password" : "text"}
      expand={expand}
    >
      {children}
    </InputWithAddon>
  );
}
